import { gql } from '@apollo/client';

import APPOINTMENTS_FRAGMENT from '../appointments';
import baseFields from '../base';
import TRANSACTION_TYPES_FRAGMENT from '../services/transactionTypes';
import USER_IN_TRANSACTION from './userInTransaction';

const TRANSACTIONS_FRAGMENT = gql`
  ${USER_IN_TRANSACTION}
  ${APPOINTMENTS_FRAGMENT}
  ${TRANSACTION_TYPES_FRAGMENT}
  fragment TransactionsFragment on Transaction {
    ${baseFields}
    returnShippingAddress
    reference
    description
    requiredScanDoc
    appointment {
      ...AppointmentsFragment
    }
    signatories
    isPaid
    transactionType {
     ...TransactionTypesFragment
      serviceType {
        id
        name
      }
    }
    clientFee
    createdBy {
      ...UserInTransaction
    }
    assigners {
      ...UserInTransaction
    }
  }
`;
export default TRANSACTIONS_FRAGMENT;
